import React, { useEffect, useState } from 'react';
import {
    Typography,
    Grid,
    Card,
    CardActionArea,
    CardContent,
    CircularProgress
} from '@material-ui/core';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import axios from 'src/utils/axios';
import FilePreviewDialog from './FilePreviewDialog';

function DosyaYonetimiDialog({ FisNo }) {
    const [dosyalar, setDosyalar] = useState([]);
    const [loading, setLoading] = useState(true);

    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [previewName, setPreviewName] = useState('');
    const [previewType, setPreviewType] = useState('');

    useEffect(() => {
        if (!FisNo) return;
        setLoading(true);
        axios.get(`/GetArtemisDosyaListe/${FisNo}`)
            .then(response => {
                setDosyalar(response.data || []);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [FisNo]);

    const handleDosyaClick = (dosya) => {
        axios.get(`/ArtemisDosya/${dosya.DOSYA_ID}`, { responseType: 'blob' })
            .then((response) => {
                const blob = new Blob([response.data], { type: dosya.DOSYA_TIPI });
                const url = URL.createObjectURL(blob);
                setPreviewUrl(url);
                setPreviewName(dosya.DOSYA_ADI);
                setPreviewType(dosya.DOSYA_TIPI);
                setPreviewOpen(true);
            });
    };

    return (
        <div>
            {loading ? (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                    <CircularProgress />
                    <Typography variant="subtitle1" style={{ marginTop: '10px' }}>
                        Dosyalar yükleniyor...
                    </Typography>
                </div>
            ) : (
                <Grid container spacing={2}>
                    {dosyalar.length > 0 ? dosyalar.map((dosya) => (
                        <Grid item xs={12} sm={6} md={4} key={dosya.DOSYA_ID}>
                            <Card elevation={3} style={{ cursor: 'pointer' }}>
                                <CardActionArea onClick={() => handleDosyaClick(dosya)}>
                                    <CardContent style={{ textAlign: 'center' }}>
                                        <InsertDriveFileIcon style={{ fontSize: 48, color: '#607d8b' }} />
                                        <Typography variant="subtitle1" noWrap>
                                            {dosya.DOSYA_ADI}
                                        </Typography>
                                        <Typography variant="caption" color="textSecondary" noWrap>
                                            {dosya.TIP}
                                        </Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Grid>
                    )) : (
                        <Grid item xs={12}>
                            <Typography variant="subtitle1" align="center" color="textSecondary">
                                Bu fiş için dosya bulunmamaktadır.
                            </Typography>
                        </Grid>)}

                </Grid>
            )}
            <FilePreviewDialog
                open={previewOpen}
                onClose={() => {
                    setPreviewOpen(false);
                    if (previewUrl?.startsWith('blob:')) {
                        URL.revokeObjectURL(previewUrl);
                    }
                    setPreviewUrl(null);
                }}
                fileUrl={previewUrl}
                fileName={previewName}
                fileType={previewType}
            />
        </div>
    );
}

export default DosyaYonetimiDialog;
